document.addEventListener('DOMContentLoaded', () => {
    // Subcategory toggle
    const subcategoryToggle = document.querySelector('.subcategory-toggle');
    if (subcategoryToggle) {
        const categoriesDiv = document.getElementById('categories');
        if (categoriesDiv) {
            // Get all category links, excluding the "Cofnij do" link
            const allLinks = Array.from(categoriesDiv.querySelectorAll('a')).filter(link => 
                !link.textContent.includes('Cofnij do:')
            );
            
            // Hide links after the first 10
            if (allLinks.length > 10) {
                allLinks.slice(10).forEach(link => {
                    if (!link.classList.contains('hidden')) {
                        link.classList.add('hidden');
                    }
                });
                
                // Add click handler to toggle button
                subcategoryToggle.addEventListener('click', () => {
                    const hiddenLinks = allLinks.slice(10);
                    const areHidden = hiddenLinks[0].classList.contains('hidden');
                    
                    hiddenLinks.forEach(link => {
                        if (areHidden) {
                            link.classList.remove('hidden');
                        } else {
                            link.classList.add('hidden');
                        }
                    });
                    
                    // Update button text
                    subcategoryToggle.textContent = areHidden ? 
                        'Mniej Podkategorii' : 
                        'Więcej Podkategorii';
                });
            } else {
                // Hide the toggle button if there are 10 or fewer links
                subcategoryToggle.style.display = 'none';
            }
        }
    }
    
    // Toggle description with smooth animation
    document.querySelectorAll('.description-toggle').forEach(toggle => {
        const wrapper = toggle.closest('.category-description')?.querySelector('.description-wrapper');
        if (!wrapper) return;
        
        const content = wrapper.querySelector('.description-content');
        const fade = wrapper.querySelector('.description-fade');
        const toggleText = toggle.querySelector('.toggle-text');
        const toggleIcon = toggle.querySelector('.toggle-icon');
        
        // Get the full height of content
        const getFullHeight = () => {
            content.style.maxHeight = 'none';
            const height = content.scrollHeight;
            content.style.maxHeight = '';
            return height;
        };
        
        // Check if content needs toggle (is it taller than collapsed height?)
        const collapsedHeight = 128; // 8rem = 128px (max-h-32)
        const fullHeight = getFullHeight();
        
        if (fullHeight <= collapsedHeight) {
            // Content fits, hide toggle and fade
            toggle.style.display = 'none';
            if (fade) fade.style.display = 'none';
            content.style.maxHeight = 'none';
            return;
        }
        
        toggle.addEventListener('click', () => {
            const isCollapsed = wrapper.dataset.collapsed === 'true';
            
            if (isCollapsed) {
                // Expand
                content.style.maxHeight = fullHeight + 'px';
                wrapper.dataset.collapsed = 'false';
                if (fade) fade.style.opacity = '0';
                if (toggleText) toggleText.textContent = 'Zwiń';
                if (toggleIcon) toggleIcon.style.transform = 'rotate(180deg)';
            } else {
                // Collapse
                content.style.maxHeight = collapsedHeight + 'px';
                wrapper.dataset.collapsed = 'true';
                if (fade) fade.style.opacity = '1';
                if (toggleText) toggleText.textContent = 'Rozwiń';
                if (toggleIcon) toggleIcon.style.transform = 'rotate(0deg)';
            }
        });
    });
    
    // Mobile filter toggle
    document.querySelectorAll('.filter-toggle').forEach(toggle => {
        toggle.addEventListener('click', () => {
            const filters = document.getElementById('filters');
            filters.classList.add('fixed', 'inset-0', 'z-50', 'bg-white', 'p-6', 'overflow-y-auto');
            filters.classList.remove('hidden');
        
            
            // Add close button if it doesn't exist
            if (!filters.querySelector('.filter-close')) {
                const closeButton = document.createElement('div');
                closeButton.className = 'md:hidden flex justify-between items-center lg:mb-8';
                closeButton.innerHTML = '<svg class="cursor-pointer filter-close top-6 right-8 absolute bg-white rounded-full shadow-xl p-1.5" xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32" d="M368 368L144 144M368 144L144 368"></path></svg>';
                filters.prepend(closeButton);
            }
        });
    });
    
    // Close mobile filter
    document.addEventListener('click', (event) => {
        if (event.target.classList.contains('filter-close') || event.target.classList.contains('filter-overlay')) {
            const filters = document.getElementById('filters');
            filters.classList.remove('fixed', 'inset-0', 'z-50', 'bg-white', 'p-6', 'overflow-y-auto');
            filters.classList.add('hidden', 'md:block');
            
        }
    });
    
    // Filter by price
    const priceFrom = document.getElementById('price-from');
    const priceTo = document.getElementById('price-to');
    
    if (priceFrom && priceTo) {
        [priceFrom, priceTo].forEach(input => {
            input.addEventListener('change', () => {
                const url = new URL(window.location.href);
                
                if (priceFrom.value) {
                    url.searchParams.set('min_price', priceFrom.value);
                } else {
                    url.searchParams.delete('min_price');
                }
                
                if (priceTo.value) {
                    url.searchParams.set('max_price', priceTo.value);
                } else {
                    url.searchParams.delete('max_price');
                }
                
                window.location.href = url.toString();
            });
        });
    }
    
    // Filter by sale
    const saleCheckbox = document.getElementById('sale-true');
    if (saleCheckbox) {
        saleCheckbox.addEventListener('change', () => {
            const url = new URL(window.location.href);
            
            if (saleCheckbox.checked) {
                url.searchParams.set('on_sale', '1');
            } else {
                url.searchParams.delete('on_sale');
            }
            
            // Reset to page 1 when filtering
            url.searchParams.delete('paged');
            
            window.location.href = url.toString();
        });
    }
        
    // Color filter functionality
    document.querySelectorAll('.swatches__box').forEach(swatch => {
        swatch.addEventListener('click', () => {
            const colorSlug = swatch.dataset.colorSlug;
            const url = new URL(window.location.href);
            
            if (swatch.classList.contains('active')) {
                // Remove filter if already active
                swatch.classList.remove('active');
                url.searchParams.delete('filter_pa_color');
            } else {
                // Remove active from all swatches
                document.querySelectorAll('.swatches__box').forEach(s => {
                    s.classList.remove('active');
                });
                
                // Add active to clicked swatch
                swatch.classList.add('active');
                url.searchParams.set('filter_pa_color', colorSlug);
            }
            
            // Reset to page 1 when filtering
            url.searchParams.delete('paged');
            
            // Navigate to filtered URL
            window.location.href = url.toString();
        });
    });
    
    // Filter by rating
    document.querySelectorAll('.rating-filter').forEach(filter => {
        filter.addEventListener('change', () => {
            const rating = filter.value;
            const url = new URL(window.location.href);
            
            if (filter.checked) {
                url.searchParams.set('rating_filter', rating);
            } else {
                url.searchParams.delete('rating_filter');
            }
            
            window.location.href = url.toString();
        });
    });
    
    // Set initial values from URL
    const url = new URL(window.location.href);
    
    if (url.searchParams.has('min_price') && priceFrom) {
        priceFrom.value = url.searchParams.get('min_price');
    }
    
    if (url.searchParams.has('max_price') && priceTo) {
        priceTo.value = url.searchParams.get('max_price');
    }
    
    if (url.searchParams.has('on_sale') && saleCheckbox) {
        saleCheckbox.checked = true;
    }
    
    if (url.searchParams.has('rating_filter')) {
        const ratingId = `rating-${url.searchParams.get('rating_filter')}`;
        const ratingFilter = document.getElementById(ratingId);
        if (ratingFilter) ratingFilter.checked = true;
    }
    
    if (url.searchParams.has('attribute_pa_kolor')) {
        const colorId = url.searchParams.get('attribute_pa_kolor');
        const colorSwatch = document.querySelector(`.color-swatch[data-term-id="${colorId}"]`);
        if (colorSwatch) colorSwatch.classList.add('active');
    }


// Reset button functionality
const resetButton = document.getElementById('reset-filters');

// Check if any filter parameters are present in URL
function hasActiveFilters() {
    const url = new URL(window.location.href);
    const filterParams = ['min_price', 'max_price', 'on_sale', 'rating_filter', 'filter_pa_color'];
    
    return filterParams.some(param => url.searchParams.has(param));
}

// Show/hide reset button based on active filters
if (resetButton) {
    if (hasActiveFilters()) {
        resetButton.style.display = 'block';
    } else {
        resetButton.style.display = 'none';
    }
}

if (resetButton) {
    resetButton.addEventListener('click', () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('min_price');
        url.searchParams.delete('max_price');
        url.searchParams.delete('on_sale');
        url.searchParams.delete('rating_filter');
        url.searchParams.delete('filter_pa_color');
        url.searchParams.delete('paged');
    
        window.location.href = url.toString();
    });
}

});
